import * as api from "leaderboard-api"
import { API_TOKEN, LEADERBOARD_API_URL } from "../env"

export const initializeLeaderboardApi = () => {
  api.initializeLeaderboardApi({
    leaderboardApiUrl: LEADERBOARD_API_URL,
    apiToken: API_TOKEN,
  })
}
